"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDimensionFile = void 0;
const getDimensionFile = file => {
  return new Promise(resolve => {
    const img = new Image();
    img.onload = () => {
      resolve({
        height: img.height,
        width: img.width
      });
    };
    img.src = URL.createObjectURL(file);
  });
};
exports.getDimensionFile = getDimensionFile;